export type CachingStrategy =
  | typeof NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY
  | typeof NEXT_JS_SERVER_COMPONENT_NO_CACHE_STRATEGY
  | typeof NEXT_JS_SERVER_NEVER_STALE_CACHING_STRATEGY;

const CACHE_VALIDITY_DEFAULT_MINS = 5;

export const NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY = {
  init: {
    cache: "force-cache" as RequestCache,
    next: { revalidate: CACHE_VALIDITY_DEFAULT_MINS * 60 },
  },
};

export const NEXT_JS_SERVER_NEVER_STALE_CACHING_STRATEGY = {
  ...NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY,
  headers: () => {
    return {
      "x-cache-buster": getCacheBusterKey(CACHE_VALIDITY_DEFAULT_MINS),
    };
  },
};

export const NEXT_JS_SERVER_COMPONENT_NO_CACHE_STRATEGY = {
  init: {
    cache: "no-cache" as RequestCache,
  },
};

export const CACHE_REVALIDATE_5_MIN_MS =
  CACHE_VALIDITY_DEFAULT_MINS * 60 * 1000;

export function getCacheBusterKey(cacheMinutes: number, now = new Date()) {
  const key = Math.floor(
    (now.getHours() * 60 + now.getMinutes()) / cacheMinutes,
  );

  return `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}-${key}`;
}
